import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";
import type { LegalSection } from "../data/legal";
type LegalPageProps = {
  title: string;
  intro?: string;
  sections: LegalSection[];
};
export function LegalPage({
  title,
  intro,
  sections
}: LegalPageProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} | Eva-Maria Bast`;
  }, [title]);
  return <article className="w-full bg-cream" data-id="element-188" data-mp="i5ug2ig2uggu">
      <header className="border-b border-cream-line bg-cream-deep" data-id="element-189" data-mp="e6bsfewvfrab">
        <div className="mx-auto max-w-4xl px-5 pb-8 pt-6 md:px-10 lg:pb-10 lg:pt-8" data-id="element-190" data-mp="e3zerdy5c332">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-cocoa transition-colors duration-150 hover:text-bark" data-id="element-191" data-mp="rwp1xlpeve1r">
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-192" data-mp="11wppxky86ica" />
            Zur Startseite
          </Link>
          <h1 className="mt-4 font-serif text-5xl font-medium leading-tight text-espresso sm:text-6xl" data-id="element-193" data-mp="wxuunjj2n1ba">{title}</h1>
          {intro && <p className="mt-4 max-w-2xl text-lg font-light leading-relaxed text-cocoa" data-id="element-194" data-mp="3otxu10z47qyz">{intro}</p>}
        </div>
      </header>

      <div className="mx-auto max-w-4xl px-5 py-8 md:px-10 lg:py-10" data-id="element-195" data-mp="1n5adqmpwj5q">
        {sections.map((section, i) => <section key={section.title ?? i} className="grid gap-2 border-b border-cream-line py-6 first:pt-0 last:border-b-0 md:grid-cols-[17rem_1fr] md:items-center md:gap-16" data-id="element-196" data-mp="6mrl9tf2pnbd" data-mpi={i}>
            {section.title && <h2 className="font-serif text-2xl font-medium leading-tight text-espresso" data-id="element-197" data-mp="gil6e16uyp4r">{section.title}</h2>}
            <div className={`space-y-4 ${section.title ? "" : "md:col-span-2"}`} data-id="element-198" data-mp="ldidh2kkuof0">
              {section.blocks.map((block, j) => <div key={block.heading ?? j} data-id="element-199" data-mp="uclvs4bx6zsg" data-mpi={j}>
                  {block.heading && <h3 className="mb-1 text-base font-medium leading-snug text-espresso" data-id="element-200" data-mp="zadzdvlxgach">{block.heading}</h3>}
                  <div className="space-y-1.5" data-id="element-201" data-mp="2vett16mu3qbi">
                    {block.paragraphs.map((p, k) => <p key={k} className="whitespace-pre-line font-light leading-snug text-cocoa" data-id="element-202" data-mp="2qga36v54dudv" data-mpi={k}>
                        {p}
                      </p>)}
                  </div>
                </div>)}
            </div>
          </section>)}
      </div>
    </article>;
}